const ToastPopup = {
    success: (message) => {
      window.showToast(message, 'success');
    },
    error: (message) => {
      window.showToast(message, 'error');
    },
    info: (message) => {
      window.showToast(message, 'info');
    },
};

export default ToastPopup;
